module.exports = __webpack_public_path__ + "img/IMG_20170616_122042.17706bd0.jpg";